import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

const Sidebar = () => {
  const [user, setUser] = useState(null);

  // =====================================================
  // LOAD USER SESSION
  // =====================================================
  useEffect(() => {
    const loadUserSession = () => {
      try {
        const raw = localStorage.getItem("userSession");

        if (!raw) {
          setUser(null);
          return;
        }

        const session = JSON.parse(raw);

        if (session?.user) {
          setUser(session.user);
        } else {
          setUser(null);
        }
      } catch (error) {
        console.error("Sidebar session error:", error);
        setUser(null);
      }
    };

    // Initial load
    loadUserSession();

    // Event Listeners
    window.addEventListener("userSessionUpdated", loadUserSession);
    window.addEventListener("storage", loadUserSession);

    return () => {
      window.removeEventListener("userSessionUpdated", loadUserSession);
      window.removeEventListener("storage", loadUserSession);
    };
  }, []);

  if (!user) return null;

  // =====================================================
  // ROLE & BASE PATH
  // =====================================================
  const role = String(user?.role || user?.userlevel || "")
    .trim()
    .toUpperCase();

  let base = "";
  if (role === "ADMIN") base = "/admin/dashboard";
  if (role === "ZSM") base = "/zsm/dashboard";
  if (role === "ASM") base = "/asm/dashboard";
  if (role === "SM") base = "/sm/dashboard";

  if (!base) return null;

  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <ul className="nav">

        {/* ================= USER ROLE TITLE ================= */}
        <li className="nav-item">
          <div
            className="nav-link"
            style={{   cursor: "default", pointerEvents: "none" }}
          >
            <i className="icon-user menu-icon" />
            <span className="menu-title">{role}</span>
          </div>
        </li>

        {/* ================= ADMIN MENU ================= */}
        {role === "ADMIN" && (
          <>
            <li className="nav-item">
              <NavLink
                to={`${base}`}
                end
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-grid menu-icon" />
                <span className="menu-title">Dashboard</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to={`${base}/add-zsm`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-circle-plus  menu-icon" />
                <span className="menu-title">ADD ZSM</span>
              </NavLink>
            </li>

              <li className="nav-item">
              <NavLink
                to={`${base}/add-asm`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-circle-plus  menu-icon" />
                <span className="menu-title">ADD ASM</span>
              </NavLink>
            </li>

              <li className="nav-item">
              <NavLink
                to={`${base}/add-sm`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-circle-plus  menu-icon" />
                <span className="menu-title">ADD SM</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to={`${base}/add-dealer`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-circle-plus  menu-icon" />
                <span className="menu-title">ADD Dealer</span>
              </NavLink>
            </li>

               <li className="nav-item">
              <NavLink
                to={`${base}/asm-transfer`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-circle-plus  menu-icon" />
                <span className="menu-title">ASM Transfer</span>
              </NavLink>
            </li>

               <li className="nav-item">
              <NavLink
                to={`${base}/sm-transfer`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-circle-plus  menu-icon" />
                <span className="menu-title">Sm Transfer</span>
              </NavLink>
            </li>

               <li className="nav-item">
              <NavLink
                to={`${base}/dealer-transfer`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-circle-plus  menu-icon" />
                <span className="menu-title">Dealer Transfer</span>
              </NavLink>
            </li>


            






            <li className="nav-item">
              <NavLink
                to={`${base}/zsm-management`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-briefcase menu-icon" />
                <span className="menu-title">ZSM Management</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to={`${base}/asm-management`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-briefcase menu-icon" />
                <span className="menu-title">ASM Management</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to={`${base}/sm-management`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
               <i className="icon-briefcase menu-icon" />
                <span className="menu-title">SM Management</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to={`${base}/reports`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-file menu-icon" />
                <span className="menu-title">Reports</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to={`${base}/settings`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-lock menu-icon" />
                <span className="menu-title">Settings</span>
              </NavLink>
            </li>
          </>
        )}

        {/* ================= ZSM MENU ================= */}
        {role === "ZSM" && (
          <>
            <li className="nav-item">
              <NavLink
                to={`${base}/dashboard`}
                end
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-grid menu-icon" />
                <span className="menu-title">Dashboard</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to={`${base}/asm-management`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-people menu-icon" />
                <span className="menu-title">ASM Management</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to={`${base}/sm-management`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-user menu-icon" />
                <span className="menu-title">SM Management</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to={`${base}/sales`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-briefcase menu-icon" />
                <span className="menu-title">Sales</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to={`${base}/reports`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-chart menu-icon" />
                <span className="menu-title">Reports</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to={`${base}/settings`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-settings menu-icon" />
                <span className="menu-title">Settings</span>
              </NavLink>
            </li>
          </>
        )}

        {/* ================= ASM MENU ================= */}
        {role === "ASM" && (
          <>
            <li className="nav-item">
              <NavLink
                to={`${base}/dashboard`}
                end
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-grid menu-icon" />
                <span className="menu-title">Dashboard</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to={`${base}/sm-management`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-people menu-icon" />
                <span className="menu-title">SM Management</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to={`${base}/sales`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-briefcase menu-icon" />
                <span className="menu-title">Sales</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to={`${base}/customers`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-user menu-icon" />
                <span className="menu-title">Customers</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to={`${base}/reports`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-chart menu-icon" />
                <span className="menu-title">Reports</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to={`${base}/settings`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-settings menu-icon" />
                <span className="menu-title">Settings</span>
              </NavLink>
            </li>
          </>
        )}

        {/* ================= SM MENU ================= */}
        {role === "SM" && (
          <>
            <li className="nav-item">
              <NavLink
                to={`${base}/dashboard`}
                end
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-grid menu-icon" />
                <span className="menu-title">Dashboard</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to={`${base}/customers`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-people menu-icon" />
                <span className="menu-title">Customers</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to={`${base}/sales`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-briefcase menu-icon" />
                <span className="menu-title">Sales</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to={`${base}/orders`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-bag menu-icon" />
                <span className="menu-title">Orders</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to={`${base}/reports`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-chart menu-icon" />
                <span className="menu-title">Reports</span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to={`${base}/settings`}
                className={({ isActive }) =>
                  isActive ? "nav-link-active" : "nav-link"
                }
              >
                <i className="icon-settings menu-icon" />
                <span className="menu-title">Settings</span>
              </NavLink>
            </li>
          </>
        )}

        {/* ================= LOGOUT ================= */}
        <li className="nav-item">
          <NavLink
            to={`${base}/logout`}
            className={({ isActive }) =>
              isActive ? "nav-link-active" : "nav-link"
            }
          >
            <i className="icon-power menu-icon" />
            <span className="menu-title">Logout</span>
          </NavLink>
        </li>

      </ul>
    </nav>
  );
};

export default Sidebar;